module.exports = __webpack_public_path__ + "img/device_1002_2_select.6b970f9d.svg";